<template>
  <!-- Célébration du dimanche. Le bilan n'est plus seulement quelque chose qu'on
       va chercher sur le dashboard : la base pose une notification quand le
       bilan devient 'generated', et la file la ressort à la relance de l'app.
       C'est donc une carte qui s'ouvre SEULE, sans que personne l'ait demandée —
       d'où le bouton de partage masqué : la célébration se lit, le hub du
       dashboard reste le chemin du partage. -->
  <AppSheet
    mode="sheet"
    :is-open="isOpen"
    :breakpoints="[0, 1]"
    :initial-breakpoint="1"
    @did-dismiss="$emit('dismiss')"
  >
    <AppContent class="weekly-recap-celebration" :scroll-y="false">
      <div class="flex flex-col h-full">
        <AppModalHeader
          :title="title"
          icon="sparkles"
          show-close
          class="shrink-0"
          @close="$emit('dismiss')"
        />
        <div
          v-if="recap"
          class="flex-1 min-h-0 flex items-center justify-center px-5 py-3"
          data-testid="weekly-recap-celebration"
        >
          <WeeklyRecapCard
            class="h-full max-h-[640px] max-w-[min(88vw,380px)]"
            :recap="recap"
            :child="child"
          />
        </div>
      </div>
    </AppContent>
  </AppSheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppContent from '@/components/common/AppContent.vue'
import { useI18n } from 'vue-i18n'
import type { WeeklyRecap } from '@/models/WeeklyRecap'
import AppSheet from '@/components/common/AppSheet.vue'
import AppModalHeader from '@/components/common/AppModalHeader.vue'
import WeeklyRecapCard from './WeeklyRecapCard.vue'

const props = defineProps<{
  isOpen: boolean
  recap: WeeklyRecap | null
  /** Enfant du foyer, s'il est encore présent : donne la couleur et la scène. */
  child?: { id: string; name?: string | null; color?: string | null; avatar?: string | null }
  /** Vrai quand l'app est en vue enfant : le titre s'adresse alors à l'enfant. */
  childView?: boolean
}>()

defineEmits<{ (e: 'dismiss'): void }>()

const { t } = useI18n()

// Même partage que la notification de série (streakMilestone) : l'enfant est
// tutoyé, le parent lit le prénom de son enfant.
const title = computed(() =>
  props.childView
    ? t('weeklyRecap.celebration.childTitle')
    : t('weeklyRecap.celebration.parentTitle', { name: props.recap?.child_name_snapshot ?? '' }),
)
</script>

<style scoped>
.weekly-recap-celebration {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}
</style>
